import { SsoUserDetailsDto } from '../interfaces/sso-user-details-dto';
import { InvitationSentDto } from '../interfaces/invitation-sent-dto';
import { UserSsoLinkDto } from '../interfaces/user-sso-link-dto';
import { arrayToDate } from '../utils/date-util';

export class SsoUserDetailsHelper {
    static getLatestInvitation(user?: SsoUserDetailsDto | null): InvitationSentDto | undefined {
        const invitations = user?.userSsoLinkDtos?.flatMap(link => link.invitations)
            .filter(inv => inv.sent);
        if (invitations && invitations.length > 0) {
            return invitations.reduce((latest, current) => {
                return arrayToDate(current.sent) > arrayToDate(latest.sent) ? current : latest;
            });
        } else {
            return;
        }
    }

    static getOldestUserSsoLink(user?: SsoUserDetailsDto | null): UserSsoLinkDto | undefined {
        let userSsoLinkArray;
        if (user && user.userSsoLinkDtos?.length > 0) {
            userSsoLinkArray = user.userSsoLinkDtos.filter(usr => usr.dateCreated?.length > 0);
        }

        const isOlder = (date: number[], otherDate: number[]) => {
            if (!date || !otherDate || date.length < 3) {
                return '-';
            }

            return arrayToDate(date).getTime() < arrayToDate(otherDate).getTime();
        };

        if (userSsoLinkArray && userSsoLinkArray.length > 0) {
            return userSsoLinkArray.reduce((oldest, current) => {
                return isOlder(current.dateCreated, oldest.dateCreated) ? current : oldest;
            });
        } else {
            return;
        }
    }
}
